module.exports = __webpack_public_path__ + "assets/e4ea396008a580f03133a443a1ce20a8.png";